// Shared helpers for the follow / feed / prediction features.
// Keep sanitizeKey in sync with functions/engagement.js.

export const sanitizeKey = (s) => String(s || '').replace(/[/\\#.[\]*?]/g, '_').trim();

export const bucketKey = (type, name) => `${type === 'studio' ? 's' : 'd'}_${sanitizeKey(name)}`;

export const categoryLabel = (c) =>
  [c.discipline, c.category, c.dance].filter(Boolean).join(' · ');

export const ordinal = (n) => {
  const num = Number(n);
  if (!num) return String(n);
  const s = ['th', 'st', 'nd', 'rd'];
  const v = num % 100;
  return num + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const medalFor = (place) => ({ 1: '🥇', 2: '🥈', 3: '🥉' }[Number(place)] || '🏅');

export const timeAgo = (ms) => {
  if (!ms) return '';
  const diff = Date.now() - ms;
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(ms).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};
